export const TENANT_ROLES = [
  { value: 'administrador', label: 'Administrador' },
  { value: 'propietario', label: 'Propietario' },
  { value: 'operador', label: 'Operador administrativo' },
  { value: 'inquilino', label: 'Inquilino' },
];

export const ROLE_LABELS = Object.fromEntries(
  TENANT_ROLES.map(({ value, label }) => [value, label])
);

export const ROLES_CAN_DELETE = ['administrador', 'propietario'];
